export const isOneTimeUpsellsEnabled = new Date().toISOString() > '2025-06-20T21:00:00.00Z';
export const isFamilyPlanEnabled = new Date().toISOString() > '2025-07-02T21:00:00.00Z';
